import styles from './palette.module.scss';
import { guid } from 'services/util';

import { SHAPE, RECTANGLE } from 'constants/widgetTypes';

import cx from 'classnames';

import { ReactSVG } from 'react-svg'

const generateDataForShape = (url, desktop, mobile) => {
  return {
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": "100px",
          "height": "100px"
        },
        "fill": {
          "type": "solid",
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "stroke": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "width": 0
        },
        "flip": {
          "vertical": false,
          "horizontal": false
        },
        "animation": null,
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        },
        ...desktop
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px, 20px",
            "rotate": "0deg"
          },
          "width": "100px",
          "height": "100px"
        },
        "fill": null,
        "stroke": null,
        "flip": {
          "vertical": false,
          "horizontal": false
        },
        "animation": null,
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        },
        ...mobile,
      }
    },
    content: url
  };
}

export const lines = ['solid', 'dashed', 'dotted'].map(type => {
  return {
    id: 'line',
    name: 'Line',
    type: SHAPE,
    render: () => {
      return (
        <div className={cx(styles.line, styles[type])}></div>
      )
    },
    data: {
      properties: {
        desktop: {
          flip: {
            horizontal: false,
            vertical: false,
          },
          type: type,
          stroke: {
            color: { r: 0, g: 0, b: 0, a: 1 },
            width: 2
          },
          layout: {
            transform: {
              translate: "20px, 20px",
              rotate: "0deg",
            },
            minWidth: '50px',
            width: "300px",
            height: "auto",
          }
        },
        mobile: {
          flip: {
            horizontal: false,
            vertical: false,
          },
          stroke: {
            color: { r: 0, g: 0, b: 0, a: 1 },
            width: 2
          },
          layout: {
            transform: {
              translate: "0px, 20px",
              rotate: "0deg",
            },
            minWidth: '50px',
            width: "300px",
            height: "auto",
          }
        }
      }
    }
  };
});


export const shapes = [{
  id: 'circle',
  name: 'Circle',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.circle, styles.shape)} src='/images/shapes/circle.svg' />
  },
  data: generateDataForShape("/images/shapes/circle.svg", {}, {}),
}, {
  id: 'rectangle',
  name: 'Rectangle',
  type: RECTANGLE,
  render: () => {
    return <ReactSVG className={cx(styles.rectangle, styles.shape)} src='/images/shapes/rectangle.svg' />
  },
  data: generateDataForShape("/images/shapes/rectangle.svg", {
    border: {
      color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      width: 0,
      radius: {
        locked: true,
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    },
    background: { r: 0, g: 0, b: 0, a: 1 }
  }, {
    border: {
      color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      width: 0,
      radius: {
        locked: true,
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    },
    background: { r: 0, g: 0, b: 0, a: 1 }
  }),
}, {
  id: 'roundedRectangle',
  name: 'Rounded Rectangle',
  type: RECTANGLE,
  render: () => {
    return <ReactSVG className={cx(styles.rectangle, styles.shape)} src='/images/shapes/rectangle.svg' />
  },
  data: generateDataForShape("/images/shapes/rectangle.svg", {
    border: {
      color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      width: 0,
      radius: {
        locked: true,
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    },
    background: { r: 0, g: 0, b: 0, a: 1 },
    layout: {
      transform: {
        translate: `0px, 0px`,
        rotate: "0deg",
      },
      width: "200px",
      height: "100px",
    }
  }, {
    border: {
      color: {
        r: 255,
        g: 255,
        b: 255,
        a: 1
      },
      width: 0,
      radius: {
        locked: true,
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    },
    background: { r: 0, g: 0, b: 0, a: 1 },
    layout: {
      transform: {
        translate: `20px, 20px`,
        rotate: "0deg",
      },
      width: "200px",
      height: "100px",
    }
  })
}, {
  id: 'pentagon',
  name: 'Pentagon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.pentagon, styles.shape)} src='/images/shapes/pentagon.svg' />
  },
  data: generateDataForShape("/images/shapes/pentagon.svg", {}, {}),
}, {
  id: 'star',
  name: 'Star',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/star.svg' />
  },
  data: generateDataForShape("/images/shapes/star.svg", {}, {}),
}, {
  id: 'triangle',
  name: 'Triangle',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/triangle.svg' />
  },
  data: generateDataForShape("/images/shapes/triangle.svg", {}, {}),
}, {
  id: 'chevron',
  name: 'Chevron',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/chevron.svg' />
  },
  data: generateDataForShape("/images/shapes/chevron.svg", {}, {}),
}, {
  id: 'arrow',
  name: 'Arrow',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/arrow.svg' />
  },
  data: generateDataForShape("/images/shapes/arrow.svg", {}, {}),
}, {
  id: 'doubleArrow',
  name: 'DoubleArrow',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/doubleArrow.svg' />
  },
  data: generateDataForShape("/images/shapes/doubleArrow.svg", {}, {}),
}, {
  id: 'thinDoubleArrow',
  name: 'ThinDoubleArrow',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/thinDoubleArrow.svg' />
  },
  data: generateDataForShape("/images/shapes/thinDoubleArrow.svg", {}, {}),
}, {
  id: 'outlineArrow',
  name: 'OutlineArrow',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/outlineArrow.svg' />
  },
  data: generateDataForShape("/images/shapes/outlineArrow.svg", {}, {}),
}, {
  id: 'curveArrow',
  name: 'CurveArrow',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/curveArrow.svg' />
  },
  data: generateDataForShape("/images/shapes/curveArrow.svg", {}, {}),
}, {
  id: 'doubleCurve',
  name: 'DoubleCurve',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.star, styles.shape)} src='/images/shapes/doubleCurve.svg' />
  },
  data: generateDataForShape("/images/shapes/doubleCurve.svg", {}, {}),
}, {
  id: 'tick',
  name: 'Tick',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/tick.svg' />
  },
  data: generateDataForShape("/images/shapes/tick.svg", {}, {}),
}, {
  id: 'question',
  name: 'Question',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/question.svg' />
  },
  data: generateDataForShape("/images/shapes/question.svg", {}, {}),
}, {
  id: 'moon',
  name: 'Moon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.tick, styles.shape)} src='/images/shapes/moon.svg' />
  },
  data: generateDataForShape("/images/shapes/moon.svg", {}, {}),
}, {
  id: 'heptagon',
  name: 'Heptagon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/heptagon.svg' />
  },
  data: generateDataForShape("/images/shapes/heptagon.svg", {}, {}),
}, {
  id: 'kite',
  name: 'Kite',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/rhombus.svg' />
  },
  data: generateDataForShape("/images/shapes/rhombus.svg", {}, {}),
}, {
  id: 'hexagon',
  name: 'Hexagon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/hexagon.svg' />
  },
  data: generateDataForShape("/images/shapes/hexagon.svg", {}, {}),
}, {
  id: 'plus',
  name: 'Plus',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/plus.svg' />
  },
  data: generateDataForShape("/images/shapes/plus.svg", {}, {}),
}, {
  id: 'parallelogram',
  name: 'Parallelogram',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/parallelogram.svg' />
  },
  data: generateDataForShape("/images/shapes/parallelogram.svg", {}, {}),
}, {
  id: 'heart',
  name: 'Heart',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/heart.svg' />
  },
  data: generateDataForShape("/images/shapes/heart.svg", {}, {}),
}, {
  id: 'trapezium',
  name: 'Trapezium',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/trapezium.svg' />
  },
  data: generateDataForShape("/images/shapes/trapezium.svg", {}, {}),
}, {
  id: 'nonagon',
  name: 'Nonagon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/nonagon.svg' />
  },
  data: generateDataForShape("/images/shapes/nonagon.svg", {}, {}),
}, {
  id: 'oval',
  name: 'Oval',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/oval.svg' />
  },
  data: generateDataForShape("/images/shapes/oval.svg", {}, {}),
}, {
  id: 'octagon',
  name: 'Octagon',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/octagon.svg' />
  },
  data: generateDataForShape("/images/shapes/octagon.svg", {}, {}),
}, {
  id: 'rhombus',
  name: 'Rhombus',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/rhombus1.svg' />
  },
  data: generateDataForShape("/images/shapes/rhombus1.svg", {}, {}),
}
]

export const socialIcons = [{
  id: 'spotify',
  name: 'Spotify',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/spotify.svg' />
  },
  data: generateDataForShape("/images/shapes/spotify.svg", {}, {})
}, {
  id: 'linkedin',
  name: 'Linkedin',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/linkedin.svg' />
  },
  data: generateDataForShape("/images/shapes/linkedin.svg", {}, {})
}, {
  id: 'soundcloud',
  name: 'Soundcloud',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/soundcloud.svg' />
  },
  data: generateDataForShape("/images/shapes/soundcloud.svg", {}, {})
}, {
  id: 'thumbsup',
  name: 'Thumbs up',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/thumbsup.svg' />
  },
  data: generateDataForShape("/images/shapes/thumbsup.svg", {}, {})
}, {
  id: 'twitter',
  name: 'Twitter',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/twitter.svg' />
  },
  data: generateDataForShape("/images/shapes/twitter.svg", {}, {})
}, {
  id: 'quora',
  name: 'Quora',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/quora.svg' />
  },
  data: generateDataForShape("/images/shapes/quora.svg", {}, {})
}, {
  id: 'skype',
  name: 'Skype',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/skype.svg' />
  },
  data: generateDataForShape("/images/shapes/skype.svg", {}, {})
}, {
  id: 'youtube',
  name: 'Youtube',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/skype.svg' />
  },
  data: generateDataForShape("/images/shapes/skype.svg", {}, {})
}, {
  id: 'love',
  name: 'Love',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/love.svg' />
  },
  data: generateDataForShape("/images/shapes/love.svg", {}, {})
}, {
  id: 'facebook',
  name: 'Facebook',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/facebook.svg' />
  },
  data: generateDataForShape("/images/shapes/facebook.svg", {}, {})
}, {
  id: 'behance',
  name: 'Behance',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/behance.svg' />
  },
  data: generateDataForShape("/images/shapes/behance.svg", {}, {})
}, {
  id: 'myspace',
  name: 'Myspace',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/myspace.svg' />
  },
  data: generateDataForShape("/images/shapes/myspace.svg", {}, {})
}, {
  id: 'dribbble',
  name: 'dribbble',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/dribbble.svg' />
  },
  data: generateDataForShape("/images/shapes/dribbble.svg", {}, {})
}, {
  id: 'whatsapp',
  name: 'Whatsapp',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/whatsapp.svg' />
  },
  data: generateDataForShape("/images/shapes/whatsapp.svg", {}, {})
}, {
  id: 'reddit',
  name: 'Reddit',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/reddit.svg' />
  },
  data: generateDataForShape("/images/shapes/reddit.svg", {}, {})
}, {
  id: 'line',
  name: 'line',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/line.svg' />
  },
  data: generateDataForShape("/images/shapes/line.svg", {}, {})
}, {
  id: 'messenger',
  name: 'Messenger',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/messenger.svg' />
  },
  data: generateDataForShape("/images/shapes/messenger.svg", {}, {})
}, {
  id: 'vimeo',
  name: 'Vimeo',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/vimeo.svg' />
  },
  data: generateDataForShape("/images/shapes/vimeo.svg", {}, {})
}, {
  id: 'tumblr',
  name: 'Tumblr',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/tumblr.svg' />
  },
  data: generateDataForShape("/images/shapes/tumblr.svg", {}, {})
}, {
  id: 'yelp',
  name: 'Yelp',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/yelp.svg' />
  },
  data: generateDataForShape("/images/shapes/yelp.svg", {}, {})
}, {
  id: 'pinterest',
  name: 'Pinterest',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/pinterest.svg' />
  },
  data: generateDataForShape("/images/shapes/pinterest.svg", {}, {})
}
]

export const generalIcons = [{
  id: 'lowbattery',
  name: 'Low battery',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/lowbattery.svg' />
  },
  data: generateDataForShape("/images/shapes/lowbattery.svg", {}, {})
}, {
  id: 'batteryfull',
  name: 'Batteryfull',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/batteryfull.svg' />
  },
  data: generateDataForShape("/images/shapes/batteryfull.svg", {}, {})
}, {
  id: 'bluetooth',
  name: 'Bluetooth',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/bluetooth.svg' />
  },
  data: generateDataForShape("/images/shapes/bluetooth.svg", {}, {})
}, {
  id: 'bookmark',
  name: 'Bookmark',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/bookmark.svg' />
  },
  data: generateDataForShape("/images/shapes/bookmark.svg", {}, {})
}, {
  id: 'camera',
  name: 'Camera',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/camera.svg' />
  },
  data: generateDataForShape("/images/shapes/camera.svg", {}, {})
}, {
  id: 'briefcase',
  name: 'Briefcase',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/briefcase.svg' />
  },
  data: generateDataForShape("/images/shapes/briefcase.svg", {}, {})
}, {
  id: 'bulb',
  name: 'Bulb',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/bulb.svg' />
  },
  data: generateDataForShape("/images/shapes/bulb.svg", {}, {})
}, {
  id: 'book',
  name: 'Book',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/book.svg' />
  },
  data: generateDataForShape("/images/shapes/book.svg", {}, {})
}, {
  id: 'apps',
  name: 'Apps',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/apps.svg' />
  },
  data: generateDataForShape("/images/shapes/apps.svg", {}, {})
}, {
  id: 'calendar',
  name: 'Calendar',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/calendar.svg' />
  },
  data: generateDataForShape("/images/shapes/calendar.svg", {}, {})
}, {
  id: 'coffee',
  name: 'Coffee',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/coffee.svg' />
  },
  data: generateDataForShape("/images/shapes/coffee.svg", {}, {})
}, {
  id: 'chat',
  name: 'Chat',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/chat.svg' />
  },
  data: generateDataForShape("/images/shapes/chat.svg", {}, {})
}, {
  id: 'charging',
  name: 'Charging',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/charging.svg' />
  },
  data: generateDataForShape("/images/shapes/charging.svg", {}, {})
}, {
  id: 'clipboard',
  name: 'Clipboard',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/clipboard.svg' />
  },
  data: generateDataForShape("/images/shapes/clipboard.svg", {}, {})
}, {
  id: 'cloud download',
  name: 'Cloud download',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/clouddownload.svg' />
  },
  data: generateDataForShape("/images/shapes/clouddownload.svg", {}, {})
}, {
  id: 'cloudupload',
  name: 'Cloud upload',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/cloudupload.svg' />
  },
  data: generateDataForShape("/images/shapes/spotify.svg", {}, {})
}, {
  id: 'click',
  name: 'Click',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/click.svg' />
  },
  data: generateDataForShape("/images/shapes/click.svg", {}, {})
}, {
  id: 'clock',
  name: 'Clock',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/clock.svg' />
  },
  data: generateDataForShape("/images/shapes/clock.svg", {}, {})
}, {
  id: 'checkmark',
  name: 'Check Mark',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/checkmark.svg' />
  },
  data: generateDataForShape("/images/shapes/checkmark.svg", {}, {})
}, {
  id: 'caution',
  name: 'Caution',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/caution.svg' />
  },
  data: generateDataForShape("/images/shapes/caution.svg", {}, {})
}, {
  id: 'delete',
  name: 'Delete',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/delete.svg' />
  },
  data: generateDataForShape("/images/shapes/delete.svg", {}, {})
}, {
  id: 'diamond',
  name: 'Diamond',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/diamond.svg' />
  },
  data: generateDataForShape("/images/shapes/diamond.svg", {}, {})
}, {
  id: 'command',
  name: 'Command',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/command.svg' />
  },
  data: generateDataForShape("/images/shapes/command.svg", {}, {})
}, {
  id: 'crop',
  name: 'Crop',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/crop.svg' />
  },
  data: generateDataForShape("/images/shapes/crop.svg", {}, {})
}, {
  id: 'customize',
  name: 'Customize',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/customize.svg' />
  },
  data: generateDataForShape("/images/shapes/customize.svg", {}, {})
}, {
  id: 'compass',
  name: 'Compass',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/compass.svg' />
  },
  data: generateDataForShape("/images/shapes/compass.svg", {}, {})
}, {
  id: 'download',
  name: 'Download',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/download.svg' />
  },
  data: generateDataForShape("/images/shapes/download.svg", {}, {})
}, {
  id: 'divide',
  name: 'Divide',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/divide.svg' />
  },
  data: generateDataForShape("/images/shapes/divide.svg", {}, {})
}, {
  id: 'expand',
  name: 'Expand',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/expand.svg' />
  },
  data: generateDataForShape("/images/shapes/expand.svg", {}, {})
}, {
  id: 'envelope',
  name: 'Envelope',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/envelope.svg' />
  },
  data: generateDataForShape("/images/shapes/envelope.svg", {}, {})
}, {
  id: 'eraser',
  name: 'Eraser',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/eraser.svg' />
  },
  data: generateDataForShape("/images/shapes/eraser.svg", {}, {})
}, {
  id: 'electricity',
  name: 'Electricity',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/electricity.svg' />
  },
  data: generateDataForShape("/images/shapes/electricity.svg", {}, {})
}, {
  id: 'email',
  name: 'Email',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/email.svg' />
  },
  data: generateDataForShape("/images/shapes/email.svg", {}, {})
}, {
  id: 'exclamation',
  name: 'Exclamation',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/exclamation.svg' />
  },
  data: generateDataForShape("/images/shapes/exclamation.svg", {}, {})
}, {
  id: 'filter',
  name: 'Filter',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/filter.svg' />
  },
  data: generateDataForShape("/images/shapes/filter.svg", {}, {})
}, {
  id: 'flag',
  name: 'Flag',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/flag.svg' />
  },
  data: generateDataForShape("/images/shapes/flag.svg", {}, {})
}, {
  id: 'edit',
  name: 'Edit',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/edit.svg' />
  },
  data: generateDataForShape("/images/shapes/edit.svg", {}, {})
}, {
  id: 'file',
  name: 'File',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/file.svg' />
  },
  data: generateDataForShape("/images/shapes/file.svg", {}, {})
}, {
  id: 'happy',
  name: 'Happy',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/happy.svg' />
  },
  data: generateDataForShape("/images/shapes/happy.svg", {}, {})
}, {
  id: 'sad',
  name: 'Sad',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/sad.svg' />
  },
  data: generateDataForShape("/images/shapes/sad.svg", {}, {})
}, {
  id: 'gamepad',
  name: 'Gamepad',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/gamepad.svg' />
  },
  data: generateDataForShape("/images/shapes/gamepad.svg", {}, {})
}, {
  id: 'globe',
  name: 'Globe',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/globe.svg' />
  },
  data: generateDataForShape("/images/shapes/globe.svg", {}, {})
}, {
  id: 'menu',
  name: 'Menu',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/menu.svg' />
  },
  data: generateDataForShape("/images/shapes/menu.svg", {}, {})
}, {
  id: 'headphone',
  name: 'Headphone',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/headphone.svg' />
  },
  data: generateDataForShape("/images/shapes/headphone.svg", {}, {})
}, {
  id: 'history',
  name: 'History',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/history.svg' />
  },
  data: generateDataForShape("/images/shapes/history.svg", {}, {})
}, {
  id: 'help',
  name: 'Help',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/help.svg' />
  },
  data: generateDataForShape("/images/shapes/help.svg", {}, {})
}, {
  id: 'folder',
  name: 'Folder',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/folder.svg' />
  },
  data: generateDataForShape("/images/shapes/folder.svg", {}, {})
}, {
  id: 'gift',
  name: 'Gift',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/gift.svg' />
  },
  data: generateDataForShape("/images/shapes/gift.svg", {}, {})
}, {
  id: 'hide',
  name: 'Hide',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/hide.svg' />
  },
  data: generateDataForShape("/images/shapes/hide.svg", {}, {})
}, {
  id: 'like',
  name: 'Like',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/like.svg' />
  },
  data: generateDataForShape("/images/shapes/like.svg", {}, {})
}, {
  id: 'ideabulb',
  name: 'Ideabulb',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/ideabulb.svg' />
  },
  data: generateDataForShape("/images/shapes/ideabulb.svg", {}, {})
}, {
  id: 'lab',
  name: 'Lab',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/lab.svg' />
  },
  data: generateDataForShape("/images/shapes/lab.svg", {}, {})
}, {
  id: 'home',
  name: 'Home',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/home.svg' />
  },
  data: generateDataForShape("/images/shapes/home.svg", {}, {})
}, {
  id: 'laptop',
  name: 'Laptop',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/laptop.svg' />
  },
  data: generateDataForShape("/images/shapes/laptop.svg", {}, {})
}, {
  id: 'list',
  name: 'List',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/list.svg' />
  },
  data: generateDataForShape("/images/shapes/list.svg", {}, {})
}, {
  id: 'layer',
  name: 'Layer',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/layer.svg' />
  },
  data: generateDataForShape("/images/shapes/layer.svg", {}, {})
}, {
  id: 'keyboard',
  name: 'Keyboard',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/keyboard.svg' />
  },
  data: generateDataForShape("/images/shapes/keyboard.svg", {}, {})
}, {
  id: 'key',
  name: 'Key',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/key.svg' />
  },
  data: generateDataForShape("/images/shapes/key.svg", {}, {})
}, {
  id: 'lock',
  name: 'Lock',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/lock.svg' />
  },
  data: generateDataForShape("/images/shapes/lock.svg", {}, {})
}, {
  id: 'unlock',
  name: 'Unlock',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/unlock.svg' />
  },
  data: generateDataForShape("/images/shapes/unlock.svg", {}, {})
}, {
  id: 'magnifyingglass',
  name: 'Magnifying glass',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/magnifyingglass.svg' />
  },
  data: generateDataForShape("/images/shapes/magnifyingglass.svg", {}, {})
}, {
  id: 'locationpin',
  name: 'Location pin',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/locationpin.svg' />
  },
  data: generateDataForShape("/images/shapes/locationpin.svg", {}, {})
}, {
  id: 'logout',
  name: 'Logout',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/logout.svg' />
  },
  data: generateDataForShape("/images/shapes/logout.svg", {}, {})
}, {
  id: 'maximize',
  name: 'Maximize',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/maximize.svg' />
  },
  data: generateDataForShape("/images/shapes/maximize.svg", {}, {})
}, {
  id: 'map',
  name: 'Map',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/map.svg' />
  },
  data: generateDataForShape("/images/shapes/map.svg", {}, {})
}, {
  id: 'magicwand',
  name: 'Magicwand',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/magicwand.svg' />
  },
  data: generateDataForShape("/images/shapes/magicwand.svg", {}, {})
}, {
  id: 'magnet',
  name: 'Magnet',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/magnet.svg' />
  },
  data: generateDataForShape("/images/shapes/magnet.svg", {}, {})
}, {
  id: 'login',
  name: 'Login',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/login.svg' />
  },
  data: generateDataForShape("/images/shapes/login.svg", {}, {})
}, {
  id: 'megaphone',
  name: 'Megaphone',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/megaphone.svg' />
  },
  data: generateDataForShape("/images/shapes/megaphone.svg", {}, {})
}, {
  id: 'microphone',
  name: 'Microphone',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/microphone.svg' />
  },
  data: generateDataForShape("/images/shapes/microphone.svg", {}, {})
}, {
  id: 'mute',
  name: 'Mute',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/mute.svg' />
  },
  data: generateDataForShape("/images/shapes/mute.svg", {}, {})
}, {
  id: 'minimize',
  name: 'Minimize',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/minimize.svg' />
  },
  data: generateDataForShape("/images/shapes/minimize.svg", {}, {})
}, {
  id: 'minus',
  name: 'Minus',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/minus.svg' />
  },
  data: generateDataForShape("/images/shapes/minus.svg", {}, {})
}, {
  id: 'message',
  name: 'Message',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/message.svg' />
  },
  data: generateDataForShape("/images/shapes/message.svg", {}, {})
}, {
  id: 'mouse',
  name: 'Mouse',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/mouse.svg' />
  },
  data: generateDataForShape("/images/shapes/mouse.svg", {}, {})
}, {
  id: 'mobile',
  name: 'Mobile',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/mobile.svg' />
  },
  data: generateDataForShape("/images/shapes/mobile.svg", {}, {})
}, {
  id: 'medal',
  name: 'Medal',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/medal.svg' />
  },
  data: generateDataForShape("/images/shapes/medal.svg", {}, {})
}, {
  id: 'monitor',
  name: 'Monitor',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/monitor.svg' />
  },
  data: generateDataForShape("/images/shapes/monitor.svg", {}, {})
}, {
  id: 'pen',
  name: 'Pen',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/pen.svg' />
  },
  data: generateDataForShape("/images/shapes/pen.svg", {}, {})
}, {
  id: 'newsletter',
  name: 'Newsletter',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/newsletter.svg' />
  },
  data: generateDataForShape("/images/shapes/newsletter.svg", {}, {})
}, {
  id: 'photo',
  name: 'Photo',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/photo.svg' />
  },
  data: generateDataForShape("/images/shapes/photo.svg", {}, {})
}, {
  id: 'phone',
  name: 'Phone',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/phone.svg' />
  },
  data: generateDataForShape("/images/shapes/phone.svg", {}, {})
}, {
  id: 'pencil',
  name: 'Pencil',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/pencil.svg' />
  },
  data: generateDataForShape("/images/shapes/pencil.svg", {}, {})
}, {
  id: 'notification',
  name: 'Notification',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/notification.svg' />
  },
  data: generateDataForShape("/images/shapes/notification.svg", {}, {})
}, {
  id: 'notificationslient',
  name: 'Notification slient',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/notificationslient.svg' />
  },
  data: generateDataForShape("/images/shapes/notificationslient.svg", {}, {})
}, {
  id: 'music',
  name: 'Music',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/music.svg' />
  },
  data: generateDataForShape("/images/shapes/music.svg", {}, {})
}, {
  id: 'reload',
  name: 'Reload',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/reload.svg' />
  },
  data: generateDataForShape("/images/shapes/reload.svg", {}, {})
}, {
  id: 'right',
  name: 'Right',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/right.svg' />
  },
  data: generateDataForShape("/images/shapes/right.svg", {}, {})
}, {
  id: 'rocket',
  name: 'Rocket',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/rocket.svg' />
  },
  data: generateDataForShape("/images/shapes/rocket.svg", {}, {})
}, {
  id: 'pin',
  name: 'Pin',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/pin.svg' />
  },
  data: generateDataForShape("/images/shapes/pin.svg", {}, {})
}, {
  id: 'power',
  name: 'Power',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/power.svg' />
  },
  data: generateDataForShape("/images/shapes/power.svg", {}, {})
}, {
  id: 'protection',
  name: 'Protection',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/protection.svg' />
  },
  data: generateDataForShape("/images/shapes/protection.svg", {}, {})
}, {
  id: 'plug',
  name: 'Plug',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/plug.svg' />
  },
  data: generateDataForShape("/images/shapes/plug.svg", {}, {})
}, {
  id: 'piechart',
  name: 'Piechart',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/piechart.svg' />
  },
  data: generateDataForShape("/images/shapes/piechart.svg", {}, {})
}, {
  id: 'printer',
  name: 'Printer',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/printer.svg' />
  },
  data: generateDataForShape("/images/shapes/printer.svg", {}, {})
}, {
  id: 'shrink',
  name: 'Shrink',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/shrink.svg' />
  },
  data: generateDataForShape("/images/shapes/shrink.svg", {}, {})
}, {
  id: 'share',
  name: 'Share',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/share.svg' />
  },
  data: generateDataForShape("/images/shapes/share.svg", {}, {})
}, {
  id: 'router',
  name: 'Router',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/router.svg' />
  },
  data: generateDataForShape("/images/shapes/router.svg", {}, {})
}, {
  id: 'shoppingbag',
  name: 'Shoppingbag',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/shoppingbag.svg' />
  },
  data: generateDataForShape("/images/shapes/shoppingbag.svg", {}, {})
}, {
  id: 'settings',
  name: 'Settings',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/settings.svg' />
  },
  data: generateDataForShape("/images/shapes/settings.svg", {}, {})
}, {
  id: 'shoppingbasket',
  name: 'Shopping basket',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/shoppingbasket.svg' />
  },
  data: generateDataForShape("/images/shapes/shoppingbasket.svg", {}, {})
}, {
  id: 'shoppingcart',
  name: 'Shopping cart',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/shoppingcart.svg' />
  },
  data: generateDataForShape("/images/shapes/shoppingcart.svg", {}, {})
}, {
  id: 'server',
  name: 'Server',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/server.svg' />
  },
  data: generateDataForShape("/images/shapes/server.svg", {}, {})
}, {
  id: 'send',
  name: 'Send',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/send.svg' />
  },
  data: generateDataForShape("/images/shapes/send.svg", {}, {})
}, {
  id: 'loudspeaker',
  name: 'Loudspeaker',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/loudspeaker.svg' />
  },
  data: generateDataForShape("/images/shapes/loudspeaker.svg", {}, {})
}, {
  id: 'silent',
  name: 'Silent',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/silent.svg' />
  },
  data: generateDataForShape("/images/shapes/silent.svg", {}, {})
}, {
  id: 'support',
  name: 'Support',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/support.svg' />
  },
  data: generateDataForShape("/images/shapes/support.svg", {}, {})
}, {
  id: 'smartwatch',
  name: 'Smart watch',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/smartwatch.svg' />
  },
  data: generateDataForShape("/images/shapes/smartwatch.svg", {}, {})
}, {
  id: 'statistics',
  name: 'Statistics',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/statistics.svg' />
  },
  data: generateDataForShape("/images/shapes/statistics.svg", {}, {})
}, {
  id: 'smartphone',
  name: 'Smart phone',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/smartphone.svg' />
  },
  data: generateDataForShape("/images/shapes/smartphone.svg", {}, {})
}, {
  id: 'spectacles',
  name: 'Spectacles',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/spectacles.svg' />
  },
  data: generateDataForShape("/images/shapes/spectacles.svg", {}, {})
}, {
  id: 'target',
  name: 'Target',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/target.svg' />
  },
  data: generateDataForShape("/images/shapes/target.svg", {}, {})
}, {
  id: 'tag',
  name: 'Tag',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/tag.svg' />
  },
  data: generateDataForShape("/images/shapes/tag.svg", {}, {})
}, {
  id: 'thunder',
  name: 'Thunder',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/thunder.svg' />
  },
  data: generateDataForShape("/images/shapes/thunder.svg", {}, {})
}, {
  id: 'umbrella',
  name: 'Umbrella',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/umbrella.svg' />
  },
  data: generateDataForShape("/images/shapes/umbrella.svg", {}, {})
}, {
  id: 'toggle',
  name: 'Toggle',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/toggle.svg' />
  },
  data: generateDataForShape("/images/shapes/toggle.svg", {}, {})
}, {
  id: 'toggleoff',
  name: 'Toggle off',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/toggleoff.svg' />
  },
  data: generateDataForShape("/images/shapes/toggleoff.svg", {}, {})
}, {
  id: 'trophy',
  name: 'Trophy',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/trophy.svg' />
  },
  data: generateDataForShape("/images/shapes/trophy.svg", {}, {})
}, {
  id: 'transform',
  name: 'Transform',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/transform.svg' />
  },
  data: generateDataForShape("/images/shapes/transform.svg", {}, {})
}, {
  id: 'team',
  name: 'Team',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/team.svg' />
  },
  data: generateDataForShape("/images/shapes/team.svg", {}, {})
}, {
  id: 'upload',
  name: 'Upload',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/upload.svg' />
  },
  data: generateDataForShape("/images/shapes/upload.svg", {}, {})
}, {
  id: 'video',
  name: 'Video',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/video.svg' />
  },
  data: generateDataForShape("/images/shapes/video.svg", {}, {})
}, {
  id: 'videocamera',
  name: 'Video camera',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/videocamera.svg' />
  },
  data: generateDataForShape("/images/shapes/videocamera.svg", {}, {})
}, {
  id: 'zoomin',
  name: 'Zoomin',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/zoomin.svg' />
  },
  data: generateDataForShape("/images/shapes/zoomin.svg", {}, {})
}, {
  id: 'zoomout',
  name: 'Zoomout',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/zoomout.svg' />
  },
  data: generateDataForShape("/images/shapes/zoomout.svg", {}, {})
}, {
  id: 'website',
  name: 'Website',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/website.svg' />
  },
  data: generateDataForShape("/images/shapes/website.svg", {}, {})
}, {
  id: 'view',
  name: 'View',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/view.svg' />
  },
  data: generateDataForShape("/images/shapes/view.svg", {}, {})
}, {
  id: 'user',
  name: 'User',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/user.svg' />
  },
  data: generateDataForShape("/images/shapes/user.svg", {}, {})
}, {
  id: 'wifi',
  name: 'Wifi',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/wifi.svg' />
  },
  data: generateDataForShape("/images/shapes/wifi.svg", {}, {})
}, {
  id: 'watch',
  name: 'Watch',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/watch.svg' />
  },
  data: generateDataForShape("/images/shapes/watch.svg", {}, {})
}, {
  id: 'paperclip',
  name: 'Paper Clip',
  type: SHAPE,
  render: () => {
    return <ReactSVG className={cx(styles.shape)} src='/images/shapes/paperclip.svg' />
  },
  data: generateDataForShape("/images/shapes/paperclip.svg", {}, {})
}]